/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
/* NPM Imports Start */
import thunk from 'redux-thunk';
import { createStore, applyMiddleware, compose } from 'redux';
import { customMiddleWare } from './clientMiddleWare.js';
/* NPM Imports End */

/* Project Imports Start */
import rootReducer from './reducer/rootReducer';

/* Project Imports End */

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const enhancer = composeEnhancers(applyMiddleware(customMiddleWare, thunk));
/* CCS & Image imports Start */

/* CCS & Image imports End */

const store = createStore(rootReducer, enhancer);

export default store;
